import { TitleSection } from "./styles";
import profile1 from "../../assets/profile1.png";
import profile2 from "../../assets/profile2.jpeg";
import { useEffect, useRef, useState } from "react";
import cv from "../../assets/CV-en.pdf";

interface ITitlePageProps {
  page: number;
}

const TitlePage = ({ page }: ITitlePageProps) => {
  const [altImg, setAltImg] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    setTimeout(() => changeImage(100, page === 0), 100);
  }, [page]);

  const changeImage = (delay: number, isLeaving: boolean) => {
    const img = imgRef.current;
    img?.classList.add("tran");
    setTimeout(() => setAltImg(!isLeaving), (delay * 2) / 3);
    setTimeout(() => {
      img?.classList.remove("tran");
    }, delay);
  };

  return (
    <TitleSection>
      <div className="title-container">
        <h1>Nicholas Engelbert</h1>
        <h6>Software developer</h6>
      </div>
      <div className="img-container">
        <a href={cv} target="_blank">
          CV.
        </a>
        <img
          ref={imgRef}
          className="profile-img"
          onMouseEnter={() => changeImage(300, false)}
          onMouseLeave={() => changeImage(300, true)}
          src={altImg ? profile2 : profile1}
          alt="Nicholas Engelbert"
        />
      </div>
    </TitleSection>
  );
};

export default TitlePage;
